import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { DiagramsWrapper } from '../../../components/statistics/DiagramsWrapper';
import { gameResultStore } from '@pascal/pascal-core/shared/core/store';
import { COLOR_BY_NUMBER } from '../../../enums/colorByNumber';
import { useIdsGenerator } from '../../../hooks/useIdsGenerator';

const DiagramsBetShop = observer(({ isActive, isRemove, activeLastRound, betShopStatistic, t }) => {
  const { gameResults } = gameResultStore;
  const numberList = useMemo(() => {
    return gameResults
      .filter((item) => item?.roundData)
      .slice(0, 8)
      .map((item) => item?.roundData?.number);
  }, [gameResults]);
  const numbersColumnsKeys = useIdsGenerator(numberList, []);

  return (
    <div className={`roulette-betshop-statistics ${isActive ? 'active' : ''} ${isRemove ? 'remove' : ''} `}>
      <div className='roulette-betshop-title-row'>
        <h3 className='roulette-betshop-stat-title'>{t('STATISTICS')}</h3>
        <span className='roulette-betshop-stat-info'>
          {t('LAST')} {activeLastRound} {t('ROUND')}
        </span>
      </div>

      <div className='roulette-betshop-els'>
        {numberList.map((num, index) => (
          <div
            key={numbersColumnsKeys[index]}
            className={`roulette-betshop-el ${COLOR_BY_NUMBER[num].color} ${index === 0 ? 'active' : ''}`}
          >
            {num}
          </div>
        ))}
      </div>
      {betShopStatistic ? <DiagramsWrapper statistics={betShopStatistic[activeLastRound]} isBetShop /> : null}
    </div>
  );
});
export default DiagramsBetShop;
